export function getTenantContext() {
  let stored = {};
  try {
    stored = JSON.parse(localStorage.getItem("norm_tenant_context") || "{}");
  } catch (e) {}
  const tenantKey =
    (stored.tenantKey || "").trim() ||
    (import.meta.env.VITE_TENANT_KEY || "").trim() ||
    "default-tenant";
  const workspaceKey =
    (stored.workspaceKey || "").trim() ||
    (import.meta.env.VITE_WORKSPACE_KEY || "").trim() ||
    "default-workspace";
  return { tenantKey, workspaceKey };
}

